import React from "react"
import { useSelector } from "react-redux"
import { Button, TextField, Paper, Typography } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Formik, Form } from "formik";
import { typeAPI } from "../services/TypeAPI";
import * as Yup from "yup";
import Swal from 'sweetalert2'
import './edittype.css'

const AddType = ({ isMobile, closeNav }) => {
    const navigate = useNavigate();
    const { isLoading } = useSelector(state => state.user)
    const { DataType, DataTypeAdmin } = useSelector(state => state.type)

    const FormSchema = Yup.object().shape({
        name: Yup.string()
            .min(3, "ป้อนอักษรอย่างน้อย 5 ตัว")
            .max(255, "ป้อนอักษรมากสุด 255 ตัว")
            .trim()
            .required("ป้อนชื่อเอกสาร"),
        dir: Yup.string()
            .min(3, "ป้อนอักษรอย่างน้อย 5 ตัว")
            .max(255, "ป้อนอักษรมากสุด 255 ตัว")
            .trim()
            .required("ป้อนชื่อที่่อยู่ของเอกสาร สำหรับแสดง"),
    }
    );

    const useStyles = makeStyles(theme => ({
        leftIcon: {
            marginRight: theme.spacing(1)
        },
        root: {
            padding: theme.spacing(4, 3)
        },
        container: {
            display: "block",
            flexWrap: "wrap"
        },
        textField: {
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2),
            marginTop: theme.spacing(1),
            width: 400
        },
        button: {
            marginTop: theme.spacing(2)
        },
        mt_1: {
            margin: theme.spacing(3)
        }
    }));

    const classes = useStyles();

    return (
        !isLoading && <Formik
            validationSchema={FormSchema}
            initialValues={{ name: "", dir: "" }}
            onSubmit={async (values, { setSubmitting }) => {
                try {
                    let arraycheck = []
                    if (Array.isArray(DataTypeAdmin) && DataTypeAdmin.length >= 1) {
                        arraycheck = DataTypeAdmin
                    }
                    else if (Array.isArray(DataType) && DataType.length >= 1) {
                        arraycheck = DataType
                    }
                    let findType = arraycheck.find((res) => res.name == values.name)
                    let findDir = arraycheck.find((res) => res.dir == values.dir)
                    if (findType) throw { message: `ชื่อ Type ${values.name}ซ้ำ` }
                    if (findDir) throw { message: `ชื่อ Dir ${values.dir}ซ้ำ` }
                    setSubmitting(true)
                    Swal.fire({
                        title: `ยืนยันที่จะเพิ่ม ${values.name} ?`,
                        confirmButtonColor: "#6ab23a",
                        showCancelButton: true,
                        confirmButtonText: "OK!",
                    }).then(result => {
                        if (result.isConfirmed) {
                            typeAPI.createType({ name: values.name, dir: values.dir })
                                .then((res) => {
                                    if (res.status == 200) {
                                        Swal.fire({
                                            icon: 'success',
                                            confirmButtonColor: "#6ab23a",
                                            text: `เพิ่ม ${values.name} เรียบร้อยแล้ว`,
                                            timer: 5000
                                        }).then(() => {
                                            navigate('/manage-type')
                                        })
                                    }
                                    else {
                                        Swal.fire({
                                            icon: 'error',
                                            confirmButtonColor: "#6ab23a",
                                            text: `${res.message}`,
                                            timer: 5000
                                        })
                                    }
                                    setSubmitting(false)
                                })
                                .catch((error) => {
                                    Swal.fire({
                                        icon: 'error',
                                        confirmButtonColor: "#6ab23a",
                                        text: `${error.message}`,
                                        timer: 5000
                                    })
                                    setSubmitting(false)
                                })
                        }
                    })
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        confirmButtonColor: "red",
                        text: error.message,
                        timer: 5000
                    })
                }
            }}
        >
            {({
                values,
                handleChange,
                isSubmitting,
                touched,
                errors,
            }) => (
                <Form className='container h-100vh' style={{ display:closeNav ? 'block':isMobile?'none':'block', marginTop: !isMobile ? 0 : '70px', justifyContent: 'flex-end', padding: !isMobile ? 'none':'0' }}>
                    <Paper className={`${classes.root} col-root`} style={{ boxShadow: 'none', padding: '3%'}}>
                        <h3 style={{ fontSize: '38px'}}>เพิ่มประเภทเอกสาร</h3>
                        
                        <TextField
                            label="Name"
                            className={`${classes.textField} `}
                            helperText="ชื่อ Type ที่โชว์ในหน้าขอเอกสาร"
                            name={"name"}
                            value={values.name}
                            onChange={handleChange}
                            style={{ marginTop: '2%'}}
                        />
                        <TextField
                            label="Directory"
                            className={`${classes.textField} `}
                            helperText="ชื่อ Folder ที่ใส่ไฟล์บน Server"
                            name={"dir"}
                            value={values.dir}
                            onChange={handleChange}
                            style={{ marginTop: '2%'}}
                        />
                        

                        <Typography component="div">
                            {errors.name && touched.name ? (
                                <div style={{ color: "#FF3333" }}>{errors.name}</div>
                            ) : null}
                            {errors.dir && touched.dir ? (
                                <div style={{ color: "#FF3333" }}>{errors.dir}</div>
                            ) : null}

                        </Typography>
                        <Button
                            type="submit"
                            disabled={isSubmitting}
                            variant="contained"
                            style={{
                                textTransform: 'none', backgroundColor: "#6ab23a", color: 'white', cursor: 'pointer', marginTop: '4%'
                            }}
                            className={classes.button}
                        >
                            บันทึก
                        </Button>
                    </Paper>
                </Form>)}
        </Formik>
    )
}
export default AddType